<template>
  <div class="d-flex flex-column gap" id="module_properties">
    <!-- Flyer -->
    <div class="flyer_container" v-if="mainStore.module.url_flyer != ''">
      <img :src="mainStore.module.url_flyer" alt="Flyer de l'épreuve" />
    </div>
    <div v-if="mainStore.is_default_mode">
      <!-- Limite de participants -->
      <div class="module_property" v-if="!mainStore.module.hide_nb_inscrits">
        <div class="spo-card pa-2 rounded">
          <v-icon icon="mdi-account-group" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Nombre de participants</div>
          <div class=" font-weight-bold">

            {{ mainStore.module.nb_inscrits }}<span v-if="mainStore.module.has_limite_participants_globale">/{{
              mainStore.module.metadatas.nb_limite_globale }}</span>
          </div>
        </div>
      </div>
      <!-- Transfert de dossards -->
      <div class="module_property">
        <div class="spo-card pa-2 rounded">
          <v-icon icon="mdi-account-arrow-left" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Transfert de dossards</div>
          <div class="font-weight-bold">
            <div v-if="mainStore.module.autoriser_transfert_dossard">
              Autorisé
              <span v-if="mainStore.module.has_limite_transfert_dossard">
                jusqu'au {{ $moment(mainStore.module.metadatas.limite_transfert_dossard).format("D MMMM YYYY") }}
              </span>
            </div>
            <div v-else>Non autorisé</div>
          </div>
        </div>
      </div>
      <!-- Changement de course -->
      <div class="module_property">
        <div class="spo-card pa-2 rounded">
          <v-icon icon="mdi-swap-horizontal" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Changement de course</div>
          <div class=" font-weight-bold">
            <div v-if="mainStore.module.autoriser_changement_course">
              Autorisé
              <span v-if="mainStore.module.has_limite_changement_course">
                jusqu'au {{ $moment(mainStore.module.metadatas.limite_changement_course).format("D MMMM YYYY") }}
              </span>
            </div>
            <div v-else>Non autorisé</div>
          </div>
        </div>
      </div>
      <!-- Inscriptions multi courses -->
      <div class="module_property">
        <div class="spo-card pa-2 rounded">
          <v-icon icon="mdi-account-details" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Inscription multi courses</div>
          <div class="font-weight-bold">
            <div v-if="mainStore.module.inscription_plusieurs_courses">Autorisé</div>
            <div v-else>Non autorisé</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Action buttons -->
    <div class="d-flex flex-column justify-start flex-wrap sm-gap">
      <!-- Bouton accès fiche -->
      <SportipsButton color="primary-dark" icon="mdi-account-outline" chevron full-width toPage="FicheCoureur">
        Accèder à ma fiche
      </SportipsButton>


      <!-- Lien page race -->
      <SportipsButton v-if="mainStore.is_default_mode && mainStore.module.has_page_race" :href="'https://sportips.fr/race/' + mainStore.module.base
        + '/inscriptions'" target="_blank" color="dark" icon="mdi-format-list-numbered" chevron full-width>
        Liste des participants
      </SportipsButton>
      <SportipsButton v-else-if="mainStore.is_default_mode && !mainStore.module.hide_list_inscrits"
        toPage="InscriptionsList" color="dark" icon="mdi-format-list-numbered" chevron full-width>
        Liste des participants
      </SportipsButton>


      <SportipsButton v-if="mainStore.module.has_preinscription || mainStore.module.some_races_have_preinscription"
        toPage="ListPreInscriptions" color="dark" icon="mdi-account-clock-outline" chevron full-width>Les
        préinscriptions</SportipsButton>

      <SportipsButton v-if="mainStore.module.has_liste_inscrits_private" toPage="VerifyInscription" color="dark"
        icon="mdi-account-clock-outline" chevron full-width>
        Vérifier mon inscription
      </SportipsButton>

      <SportipsButton v-if="mainStore.module.base == 'LCE26'" toPage="LCE26Performance" color="dark"
        icon="mdi-chart-line" chevron full-width>Liste des performances</SportipsButton>

      <!-- View bourse aux dossards -->
      <SportipsButton v-if="mainStore.module.has_bourse_dossards && !mainStore.module.has_liste_attente_bourse"
        toPage="BourseDossards" color="dark" icon="mdi-cash" chevron full-width>Bourse aux dossards</SportipsButton>

      <SportipsButton v-if="mainStore.module.has_liste_attente_bourse" toPage="ListeAttenteBourse" color="dark"
        icon="mdi-clock-alert-outline" chevron full-width>Liste d'attente</SportipsButton>
      <!-- Lien réglement -->

      <SportipsButton v-if="mainStore.module.url_reglement != ''" :href="mainStore.module.url_reglement" target="_blank"
        color="dark" icon="mdi-link" chevron full-width>
        <span v-if="mainStore.is_default_mode">Réglement de l'épreuve</span>
        <span v-else>CGV de l'événement</span>
      </SportipsButton>



      <SportipsButton v-if="mainStore.module.has_url_site" :href="mainStore.module.metadatas.url_site" target="_blank"
        color="dark" icon="mdi-link" chevron full-width>
        <span v-if="mainStore.is_default_mode">Site de l'épreuve</span>
        <span v-else>Site de l'événement</span>
      </SportipsButton>
      <!-- Lien facebook -->
      <a v-if="mainStore.module.has_url_fb" :href="mainStore.module.metadatas.url_fb" target="_blank">
        <v-btn block color="dark" prepend-icon="mdi-facebook">Facebook de l'épreuve</v-btn>
      </a>
      <SportipsButton v-if="mainStore.module.has_url_fb" :href="mainStore.module.metadatas.url_fb" target="_blank"
        color="dark" icon="mdi-facebook" chevron full-width>
        Facebook de l'épreuve
      </SportipsButton>
      <!-- Lien contact Sportips -->
      <SportipsButton v-if="!mainStore.module.hide_contact_sportips_accueil" href="https://sportips.fr/contact.php"
        target="_blank" color="dark" icon="mdi-email-outline" chevron full-width>
        Contacter Sportips
      </SportipsButton>

      <SportipsButton v-if="mainStore.module.mail_orga_accueil" :href="'mailto:' + mainStore.module.mail_orga_accueil"
        color="dark" icon="mdi-email-outline" chevron full-width>
        Contacter l'organisateur
      </SportipsButton>

      <!-- Extra buttons link -->
      <SportipsButton v-for="(extra, index) in extra_buttons" :key="index" :href="extra.valeur" target="_blank"
        color="dark" icon="mdi-link" chevron full-width>
        {{ extra.label }}
      </SportipsButton>
      <SportipsButton v-if="mainStore.module.has_url_resultats" :href="mainStore.module.url_resultats" target="_blank"
        color="dark" icon="mdi-chart-line" chevron full-width>
        Les résultats
      </SportipsButton>


    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  data() {
    return {
      extra_buttons: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  async created() {
    this.extra_buttons = await this.mainStore.module.get_extra_buttons_accueil();
  },
};
</script>

<style lang="scss" scoped>
.extra_buttons_link:hover {
  text-decoration: none !important;
}
</style>